import React from "react"

import { Provider } from "react-redux"
import store from "../store/index"
import { BrowserRouter, MemoryRouter, Route, Switch } from "react-router-dom"

import Home from "./Home"
import Question from "./Question"
import Result from "./Result"
import Loading from "./Loading"
import LanguageSelection from "./LanguageSelection"
import Initialization from "./Initialization"

export class Router extends React.Component {
  componentDidMount() {
    window.Kakao.init("9bc162637f64659b69720a7b7409c14e")
  }

  render() {
    return (
      <Provider store={store}>
        <div id="wrapper">
          <MemoryRouter>
            <Initialization />
            {/* <BrowserRouter> */}
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/languageSelection" component={LanguageSelection} />
              <Route path="/question" component={Question} />
              <Route path="/result" component={Result} />
              <Route path="/loading" component={Loading} />
            </Switch>
            {/* </BrowserRouter> */}
          </MemoryRouter>
        </div>
      </Provider>
    )
  }
}

export default Router
